import { getAPIUrl } from '../helpers/App';

export const APIstatsOverview = params => (
  window.axios.get(getAPIUrl('/stats/overview'), { params })
    .then(response => (response))
);

export const APIstatsDashboardOverview = params => (
  window.axios.get(getAPIUrl('/stats/dashboard'), { params })
    .then(response => (response))
);

export const APIstatsDownloads = params => (
  window.axios.get(getAPIUrl('/stats/downloads'), { params })
    .then(response => (response))
);
